import React, { useEffect, useState } from "react";
import "../css/wb_template.css";
import { Link } from "react-router-dom";
import Eye from "../Assets/images/eye.png";
import Delete from "../Assets/images/delete.png";
import Plus from "../Assets/images/plus.png";
import { apiCall } from '../services/authServieces';
import ShowSnackBar from "../components/snackBar";
import AlertDialog from '../components/deleteComponent';
import { deleteTemplate } from '../services/templateService';
import PdfIcon from '../Assets/images/pdf.png';
import TablePagination from '@mui/material/TablePagination';
import urlImage from '../Assets/images/domain.png'
import phoneImage from '../Assets/images/phone-call-white.png'
import { ClipLoader } from "react-spinners";

const WbTemplate = () => {
  const [loading, setLoading] = useState(false);
  const [isTemplate, setIsTemplate] = useState([]);
  const [snackBar, setSnackBar] = useState({ open: false, severity: '', message: '' });
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedTemplateName, setSelectedTemplateName] = useState(null);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [page, setPage] = useState(0); // Pagination: current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Pagination: rows per page
  const [totalTemplates, setTotalTemplates] = useState(0); // Total number of templates

  const handleClickOpen = (templateName, templateId) => {
    setSelectedTemplateName(templateName);
    setSelectedTemplateId(templateId);
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleDelete = async (templateId, templateName) => {
    try {

      const res = await deleteTemplate({ payload: templateId });

      if (res.success) {
        setSnackBar({
          open: true,
          severity: "success",
          message: res.message,
        });

        // Filter out the deleted template without reloading
        const updatedTemplates = isTemplate.filter(template => template.temp_id !== templateId);
        setIsTemplate(updatedTemplates);

        // Optionally, refetch templates to ensure pagination is accurate
        if (updatedTemplates.length === 0 && page > 0) {
          setPage(page - 1); // Move to the previous page if the current one is empty
        } else {
          // Re-fetch data to ensure updated state for pagination
          fetchTemplates();
        }
      }
    } catch (err) {
      setSnackBar({
        open: true,
        severity: "error",
        message: err?.response?.data?.message || "An error occurred",
      });
    }
    setOpenDialog(false);
  };




  useEffect(() => {
    fetchTemplates();
  }, [page, rowsPerPage]); // Re-fetch data on page or rowsPerPage change

  const fetchTemplates = async () => {
    try {
      const res = await apiCall({
        endpoint: `templates/get-templates-pagination?page=${page + 1}&limit=${rowsPerPage}`,
        method: 'GET',
      });

      if (res?.success) {
        const formattedData = res.data.map(item => {
          const date = new Date(item.date_time);
          const formattedDate = date.toLocaleString('en-GB', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          });

          return {
            ...item,
            date_time: formattedDate,
          };
        });

        setIsTemplate(formattedData || []);
        setTotalTemplates(res.totalCount);
      }
    } catch (error) {
      setSnackBar({
        open: true,
        severity: 'error',
        message: error?.response?.data?.message || "An error occurred",
      });
    }
  };

  useEffect(() => {
    const getTemplates = async () => {
      setLoading(true)
      try {
        const res = await apiCall({
          endpoint: `templates/get-templates-pagination?page=${page + 1}&limit=${rowsPerPage}`,
          method: 'GET',
        });

        if (res?.success) {
          const formattedData = res.data.map(item => {
            const date = new Date(item.date_time);
            const formattedDate = date.toLocaleString('en-GB', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
            });

            return {
              ...item,
              date_time: formattedDate,
            };
          });

          setIsTemplate(formattedData || []);
          setTotalTemplates(res.totalCount); // Update total templates
        }
      } catch (error) {
        setSnackBar({
          open: true,
          severity: 'error',
          message: error?.response?.data?.message || "An error occurred",
        });
      }
      finally {
        setLoading(false);
      }
    };

    getTemplates();
  }, [page, rowsPerPage]); // Re-fetch data on page or rowsPerPage change

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset page to 0 when rows per page changes
  };

  const handleCloseSnackBar = () => {
    setSnackBar((prevState) => ({ ...prevState, open: false }));
  };

  const handlePreview = (template) => {
    setSelectedTemplate(template); // Set the selected template for the modal
  };


  const getMediaType = (mediaUrl) => {
    // Extract the file extension from the URL
    const fileExtension = mediaUrl?.split('.').pop().toLowerCase();

    // Determine media type based on file extension
    if (['png', 'jpeg', 'jpg', 'gif'].includes(fileExtension)) {
      return 'image';
    }
    if (fileExtension === 'mp4') {
      return 'video';
    }
    if (['pdf'].includes(fileExtension)) {
      return 'document';
    }

    return null; // Unknown type
  };


  return (
    <>
      <div className="Template_id_contian1">
        <h4 className="Head_titleTemplate">
          Manage Template
          <Link className="add_btn1 text-nowrap WMadd_btntemp1" to="/wbaddtemplate">
            <img src={Plus} alt="img" /> Add Template
          </Link>
        </h4>
        <div className="Template_id_Card1">
          <div className="table_contain" id="tableContain">
            <table className="Table" id="Table">
              <thead>
                <tr>
                  <th>S_No.</th>
                  <th>Template Name</th>
                  <th>Template Type</th>
                  <th>Preview</th>

                  <th>Date/Time</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {isTemplate.length > 0 ? (
                  isTemplate.map((template, index) => (
                    <tr key={"Template" + index}>
                      <td>{index + 1}</td>
                      <td>{template.templatename}</td>
                      <td>{template.template_type}</td>
                      <td>
                        <button
                          className="download_icon"
                          onClick={() => handlePreview(template)} // Pass template data to modal
                          data-bs-toggle="modal"
                          data-bs-target="#Preview_modal"
                        >
                          <img src={Eye} alt="preview" />
                        </button>
                      </td>

                      <td>{template.date}, {template.temp_creation_time}</td>
                      <td title={template?.temp_remarks}>
                        {['ACCEPTED', 'REJECTED', 'PENDING', 'APPROVED','SUSPENDED'].includes(template.temp_status) && (
                          <span className={template.temp_status.toLowerCase()}>
                            {template.temp_status}
                          </span>
                        )}
                      </td>
                      <td>
                        <button className="del_btn1" onClick={() => handleClickOpen(template.templatename, template.template_id)}>
                          <img src={Delete} alt="delete" />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={10} className="text-center">No Templates Found</td>
                  </tr>
                )}
              </tbody>
            </table>
            {/* Delete confirmation dialog */}
            <AlertDialog
              open={openDialog}
              onClose={handleClose}
              templateName={selectedTemplateName}
              handleDelete={() => handleDelete(selectedTemplateId, selectedTemplateName)}
            />
          </div>

          {/* Table Pagination */}
          <TablePagination
            component="div"
            count={totalTemplates}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]} // Define rows per page options
          />
        </div>
      </div>

      {/* Modal for Template Preview */}
      <div className="modal fade" id="Preview_modal" tabIndex="-1" aria-labelledby="Preview_modal_Label" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content modal-content1">
            <div className="modal-header">
              <h5 className="modal-title" id="Preview_modal_Label">
                Template Preview
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body ">
              {selectedTemplate ? (

                <div className="Modal_Table_contain Modal_Table_contain_crouser">
                  <div className="templateContainer">
                    <div
                      style={{
                        backgroundColor: '#ffffff',
                        borderRadius: '10px',
                        width: '100%',
                      }}
                    >

                      {selectedTemplate && selectedTemplate.template_type === 'rich_card' && (
                        <div className="templateHeader templateHeader_bg">


                          {/* Check for media type and render accordingly */}


                          {
                            selectedTemplate.viResponse &&
                            (() => {
                              const res1 = JSON.parse(selectedTemplate.viResponse);
                              const mediaUrl = res1?.templateModel?.standAlone?.mediaUrl;
                              const mediaType = getMediaType(mediaUrl);

                              if (mediaType === 'image') {
                                return <img src={mediaUrl} alt="image preview" style={{ height: 'inherit', width: '100%', borderRadius: '10px' }} />;
                              }

                              if (mediaType === 'video') {
                                return (
                                  <video autoPlay controls className="uploaded-video viewMedia">
                                    <source src={mediaUrl} />
                                    Your browser does not support the video tag.
                                  </video>
                                );
                              }

                              if (mediaType === 'document') {
                                return (
                                  <div>
                                    <a href={mediaUrl} target="_blank" rel="noopener noreferrer">
                                      View Document
                                    </a>
                                  </div>
                                );
                              }



                              return <p>Unsupported media type</p>; // In case of an unknown media type
                            })()
                          }
                        </div>


                      )}



                      {selectedTemplate && selectedTemplate.template_type === 'text_message_with_pdf' && (
                        <div className="templateHeader templateHeader_bg">


                          {/* Check for media type and render accordingly */}


                          {
                            selectedTemplate.viResponse &&
                            (() => {
                              const res1 = JSON.parse(selectedTemplate.viResponse);
                              const mediaUrl = res1?.templateModel?.documentUrl;


                              if (mediaUrl) {
                                return (
                                  <div>

                                    <a href={mediaUrl} target="_blank" rel="noopener noreferrer">

                                      <img src={PdfIcon} alt='pdficon' className="w-25"></img>

                                    </a>
                                  </div>
                                );
                              }

                              return <p>Unsupported media type</p>; // In case of an unknown media type
                            })()



                          }


                        </div>
                      )}



                      {
                        selectedTemplate && selectedTemplate.template_type !== 'carousel' && (
                          <>
                            {selectedTemplate.viResponse && (() => {
                              const res1 = JSON.parse(selectedTemplate.viResponse);
                              const cardTitle = res1?.templateModel?.standAlone?.cardTitle;
                              const cardDescription = res1?.templateModel?.standAlone?.cardDescription;

                              if (cardTitle && cardDescription) {
                                return (
                                  <>
                                    <h4 className="mt-3 mb-0 text-start">{cardTitle}</h4>
                                    <p className="mt-2 mb-0 text-start">{cardDescription}</p>
                                  </>
                                );
                              } else {
                                // If no cardTitle or cardDescription, show a fallback text message
                                const textMessageContent = res1?.templateModel?.textMessageContent;
                                return textMessageContent ? (
                                  <p className="mt-2 mb-0 text-start">{textMessageContent}</p>
                                ) : <p></p>;
                              }
                            })()}
                          </>
                        )
                      }


                    </div>



                    {/* carousel starting */}

                    {selectedTemplate.viResponse && (() => {
                      const res1 = JSON.parse(selectedTemplate.viResponse);
                      const carouselList = res1?.templateModel?.carouselList;

                      return carouselList && carouselList.length > 0 ? (
                        <div className="carousel-container">
                          {carouselList.map((carouselItem, index) => (
                            <div key={index} className="carousel-card">

                              {/* Render Media */}
                              {carouselItem.mediaUrl && (
                                <div className="media-container">
                                  {getMediaType(carouselItem.mediaUrl) === 'image' && (
                                    <img src={carouselItem.mediaUrl} alt="carousel item" className="carousel-image" />
                                  )}
                                  {getMediaType(carouselItem.mediaUrl) === 'video' && (
                                    <video autoPlay controls className="carousel-video">
                                      <source src={carouselItem.mediaUrl} />
                                      Your browser does not support the video tag.
                                    </video>
                                  )}
                                  {getMediaType(carouselItem.mediaUrl) === 'document' && (
                                    <div>
                                      <a href={carouselItem.mediaUrl} target="_blank" rel="noopener noreferrer">View Document</a>
                                    </div>
                                  )}
                                </div>
                              )}

                              <h4>{carouselItem.cardTitle}</h4>
                              <p>{carouselItem.cardDescription}</p>
                              {/* Suggestions */}
                              {carouselItem.suggestions && carouselItem.suggestions.length > 0 && (
                                <div className="suggestions-container">
                                  {carouselItem.suggestions.map((suggestion, suggestionIndex) => {
                                    if (suggestion.suggestionType === 'url_action') {
                                      return (
                                        <button key={suggestionIndex} className="sugesstion_btn" onClick={() => window.open(suggestion.url, '_blank')}>
                                          {suggestion.displayText}
                                        </button>
                                      );
                                    }
                                    if (suggestion.suggestionType === 'reply') {
                                      return (
                                        <button key={suggestionIndex} className="sugesstion_btn">
                                          {suggestion.displayText}
                                        </button>
                                      );
                                    }
                                    if (suggestion.suggestionType === 'dialer_action') {
                                      return (
                                        <button key={suggestionIndex} className="sugesstion_btn call_b">
                                          <a href={suggestion.phoneNumber} className="a_call">
                                            {suggestion.displayText}
                                          </a>
                                        </button>
                                      );
                                    }
                                    return null;
                                  })}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p></p>
                      );
                    })()}

                    {/* carousel ending */}


                    {/* staring suggestion */}

                    {/* richcardalone Section  START*/}
                    <div className="suggestions-container mt-3 d-inline-grid">
                      {selectedTemplate.viResponse && (() => {
                        const res1 = JSON.parse(selectedTemplate.viResponse);
                        const suggestions = res1?.templateModel?.standAlone?.suggestions;

                        return suggestions && suggestions.length > 0 ? (
                          suggestions.map((suggestion, index) => {
                            // Check if suggestion type is 'url_action' and display button
                            if (suggestion.suggestionType === 'url_action') {
                              return (

                                <button key={suggestion.suggestionId} className="btn btn-primary mb-2" onClick={() => window.open(suggestion.url, '_blank')}>
                                  <img src={urlImage} alt="urlimage" className="img_btn_icon" />
                                  {suggestion.displayText}
                                </button>
                              );
                            }

                            if (suggestion.suggestionType === 'reply') {
                              return (
                                <button key={suggestion.suggestionId} className="btn btn-primary mb-2">
                                  {suggestion.displayText}
                                </button>
                              );
                            }
                            if (suggestion.suggestionType === "dialer_action") {
                              return (

                                <button key={suggestion.suggestionId} className="btn btn-primary mb-2 call_b">
                                  <a href={suggestion.phoneNumber} className="a_call">
                                    <img src={phoneImage} alt="urlimage" className="img_btn_icon" />
                                    {suggestion.displayText}
                                  </a>
                                </button>

                              );
                            }



                            return null;
                          })



                        ) : (
                          <p></p>
                        );
                      })()}
                    </div>

                    {/* richcardalone Section  END*/}

                    {/*Text Suggestion for pdf START */}

                    <div className="suggestions-container mt-3 d-inline-grid">
                      {selectedTemplate.viResponse && (() => {
                        const res1 = JSON.parse(selectedTemplate.viResponse);
                        const suggestions = res1?.templateModel?.suggestions;

                        return suggestions && suggestions.length > 0 ? (
                          suggestions.map((suggestion, index) => {
                            // Check if suggestion type is 'url_action' and display button
                            if (suggestion.suggestionType === 'url_action') {
                              return (

                                <button key={suggestion.suggestionId} className="btn btn-primary mb-2" onClick={() => window.open(suggestion.url, '_blank')}>
                                  <img src={urlImage} alt="urlimage" className="img_btn_icon" />
                                  {suggestion.displayText}
                                </button>
                              );
                            }

                            if (suggestion.suggestionType === 'reply') {
                              return (
                                <button key={suggestion.suggestionId} className="btn btn-primary mb-2">
                                  {suggestion.displayText}
                                </button>
                              );
                            }
                            if (suggestion.suggestionType === "dialer_action") {
                              return (

                                <button key={suggestion.suggestionId} className="btn btn-primary mb-2 call_b">
                                  <a href={suggestion.phoneNumber} className="a_call">
                                    <img src={phoneImage} alt="urlimage" className="img_btn_icon" />
                                    {suggestion.displayText}
                                  </a>
                                </button>

                              );
                            }



                            return null;
                          })



                        ) : (
                          <p></p>
                        );
                      })()}
                    </div>


                    {/*Text Suggestion for pdf END  */}






                    {/* ending suggestion */}



                  </div>
                </div>
              ) : (
                <p>No template selected</p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Snackbar for feedback messages */}
      <ShowSnackBar
        open={snackBar.open}
        severity={snackBar.severity}
        message={snackBar.message}
        handleClose={handleCloseSnackBar}
      />


      {loading && (
        <div className="spinnerOverlay">
          <ClipLoader loading={loading} size={50} />
        </div>
      )}
    </>
  );
};

export default WbTemplate;



